
import React from 'react';
import { connect }  from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import material from 'material-colors'

import FW_ColorPickerOption from './FW_ColorPickerOption'

const styles = theme => ({  
  mainDiv: {
    //backgroundColor: 'white',
    width: 252,
    padding: '3%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',    
    //marginight: -14px;
    //margin-bottom: -14px;
  },   
});

class FW_ColorPicker extends React.Component {

  handleClickListItem = (color) => {
    console.log('Voy a llamar con ' + color)
    if(this.props.onChange) {
      this.props.onChange(color);
    }
  }
  
  render() {
    let colorsArray = [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500'],material.black,material.white]
    
    const { classes } = this.props;
       
    return (
      <div className={classes.mainDiv}>
       {colorsArray.map(currentColor => (
            <FW_ColorPickerOption key={currentColor} color={currentColor} listener={this.handleClickListItem}/>                      
          ))}       
      </div>    
    );    
  }
}  
  
FW_ColorPicker.propTypes = {
  classes: PropTypes.object.isRequired,
};

FW_ColorPicker.contextTypes = {
  store: PropTypes.object,
};

export default connect()(withStyles(styles,{ withTheme: true })(FW_ColorPicker));



// WEBPACK FOOTER //
// ./src/containers/components/FW_ColorPicker.js